import template from './swag-cms-extensions-form-editor-settings.html.twig';
import './swag-cms-extensions-form-editor-settings.scss';

export default {
    template,

    computed: {
        item() {
            return Shopware.Store.get('swCmsDetailCurrentCustomForm').activeItem;
        },
        showGroupSettings() {
            return this.item.getEntityName() === 'swag_cms_extensions_form_group';
        },
        fieldComponentName() {
            return `swag-cms-extensions-form-editor-settings-field-type-${this.item.type}`;
        },
    },
}
